import React, { useRef,Suspense,useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import { setFilters, resetFilters} from 'reducers/filtersContractsSlice';
import { resetPagination } from 'reducers/paginationContractsSlice';
import { useNavigate } from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem  from "@mui/material/MenuItem"; 
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import PropTypes from 'prop-types'; 
import TableSortingContract from "pages/contracts/filterContract/SortingTablesContract";
import ContractPDF from "pages/contracts/generatePDF/ContractPDF";
import exportContractToExcel from "pages/contracts/filterContract/ContractExportToExcel";
 
const initialFiltersContracts= {
  idFrom:"",
  idTo:"",
  defaultStoreIdFrom:"",
  defaultStoreIdTo:"",
  useraccountIdFrom:"",
  useraccountIdTo:"",
  numberNTrom:"",
  numberNTTo:"",
  dateContractFrom:null,
  dateContractTo:null,
  ori_tras_store_idFrom: "", 
  ori_tras_store_idTo: "", 
  dest_tras_store_idFrom:"",
  dest_tras_store_idTo:""
}; 

const initialStoresToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": "",
  "name": ""
}];

const initialUserAccountToSelect = [{
  "id": "",
  "username":"",
  "firstName": "",
  "lastName1": "",
  "lastName2": "",
  "email": "",
  "aliasuser": ""
}];

const initialStateContract = [{
  "id" : 0,
  "owncontract_id":0,
  "defaultStore_id" : 0,
  "tradename" : "",
  "useraccount_id" : 0,
  "username" :"",
  "defaultformatnumber": 1,
  "number_nt":"",
  "date_contract" : "",
  "opt_tras_store_id" : 0,
  "opt_tras_tradename" : "",
  "opt_tras_shared" : false,
  "sendbyemail_opt_tras" : false,
  
  "ori_tras_store_id" : 0,
  "ori_tras_tradename" : "",
  "ori_tras_shared" : false,
  "sendbyemail_ori_tras" : false,
  
  "aut_tras_store_id" : 0,
  "aut_tras_tradename" : "",
  "aut_tras_shared" : false,
  "sendbyemail_aut_tras" : false,
  
  "dest_tras_store_id" : 0,
  "dest_tras_tradename" : "",
  "dest_tras_shared" : false,
  "sendbyemail_dest_tras" : false,
  
  "aut_dest_store_id" : 0,
  "aut_dest_tradename" : "",
  "aut_dest_shared" : false,
  "sendbyemail_aut_dest" : false,
  
  "sharedStored":"",
  "emailStored":""
    
}];
    

const ContractFilter = ({ showModalContractSettings,setShowModalContractSettings}) => {
  const {t,i18n} = useTranslation(['listDataContracts']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore);  
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const DELETE_CODE_FORMDI = useSelector((state) => state.formatDIUser.delete_code_formdi); 
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesize);  
  const [dataContract, setDataContract] = useState(initialStateContract); 
  const filtersContractsDetails = useSelector((state) => state.filtersContracts);
  const [filtersContract, setFiltersContract]= useState(filtersContractsDetails);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegContract,setNumTotRegContract]= useState(0);
  const [errorsFiltersContract, setErrorsFiltersContract] = useState({});
  const [inputTextContract, setInputTextContract] = useState("");  
  const [openDeleteRowContract,setOpenDeleteRowContract]= useState(false); 
  const [openEditRowContract,setOpenEditRowContract]= useState(false);
  const [openEditFilterContract,setOpenEditFilterContract]= useState(false);
  const [rowEditContract,setRowEditContract]= useState(initialStateContract[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorContract, setIsLoadingErrorContract] = useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE);
  const [viewPDF,setViewPDF]=useState(false);  
  const dispatch = useDispatch();
  const [activeOffsetContract, setActiveOffsetContract]= useState(false);
  const [currencyOffsetContract, setCurrencyOffsetContract] = useState(0);
  const [rangeOffsetContract, setRangeOffsetContract] = useState([{}]);
  const [storesToSelect,setStoresToSelect]= useState(initialStoresToSelect);
  const [userAccountsToSelect,setUserAccountsToSelect]= useState(initialUserAccountToSelect);
  const navigate = useNavigate(); 
  const [oriTrasTradenameToSelect,setOriTrasTradenameToSelect]= useState(initialStoresToSelect); 
  const [destTrasTradenameToSelect,setDestTrasTradenameToSelect]= useState(initialStoresToSelect); 
  const [filteredOriTrasStoreFrom, setFilteredOriTrasStoreFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexOriTrasStoreFrom, setHighlightedIndexOriTrasStoreFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredOriTrasStoreTo, setFilteredOriTrasStoreTo] = useState([]); // Opciones filtradas
  const [highlightedIndexOriTrasStoreTo, setHighlightedIndexOriTrasStoreTo] = useState(-1); // Índice de la opción resaltada 
  const [filteredTransFrom, setFilteredTransFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexDestTrasStoreFrom, setHighlightedIndexDestTrasStoreFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredTransTo, setFilteredTransTo] = useState([]); // Opciones filtradas
  const [highlightedIndexDestTrasStoreTo, setHighlightedIndexDestTrasStoreTo] = useState(-1); // Índice de la opción resaltada 
 
  const menuPermissions = useMemo(() => {
    const list = roles && roles[0] && roles[0].listmenus ? roles[0].listmenus : [];
    const has = (name) => list.some((m) => m.name === name);
    return {
      storeMaster: has('SubMenu_Settings_Contacts_Store_Master'),
      userMaster: has('SubMenu_Settings_Contacts_User_Master'),
      canCreate: has('SubMenu_Contact_Create'),
      canExcel: has('SubMenu_Contract_Handle_Excel'),
      canEdit: has('SubMenu_Contact_Edit'),
      canPrint: has('SubMenu_Contact_Print'),
      canDelete: has('SubMenu_Contact_Delete'),
      canHandleEmails: has('SubMenu_Contract_Handle_EMAILs'),
      canShowStores: has('SubMenu_Contact_View_Stores'), 

    };
  }, [roles]);

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalContractSettings) {
        setDataContract(initialStateContract);  
        setNumTotRegFilter(0);
        setNumTotRegContract(0);
        setErrorsFiltersContract({});
        setInputTextContract(""); 
        setOpenDeleteRowContract(false); 
        setOpenEditRowContract(false);
        setOpenEditFilterContract(false);
        setRowEditContract(initialStateContract[0]); 
        setIsLoadingErrorContract(false);
        setIdCodeDelete(DELETE_CODE);
        setViewPDF(false);
        setActiveOffsetContract(false);
        setCurrencyOffsetContract(0);
        setRangeOffsetContract([{}]);
        setStoresToSelect(initialStoresToSelect);
        setUserAccountsToSelect(initialUserAccountToSelect); 
        setShowModalContractSettings(false);
        dispatch(setLoading(false));
        dispatch(resetPagination());
        dispatch(resetFilters());
        setFiltersContract(initialFiltersContracts);
        setDestTrasTradenameToSelect(initialStoresToSelect);
        setOriTrasTradenameToSelect(initialStoresToSelect);
        setFilteredOriTrasStoreFrom([]);
        setHighlightedIndexOriTrasStoreFrom(-1); 
        setFilteredOriTrasStoreTo([]);  
        setHighlightedIndexOriTrasStoreTo(-1);  
        setFilteredTransFrom([]);
        setHighlightedIndexDestTrasStoreFrom(-1);  
        setFilteredTransTo([]);
        setHighlightedIndexDestTrasStoreTo(-1);  
        navigate("/home");
        return () => {};
      }
    },
    [
      setDataContract,  
      setFiltersContract,
      setNumTotRegFilter,
      setNumTotRegContract,
      setErrorsFiltersContract,
      setInputTextContract, 
      setOpenDeleteRowContract, 
      setOpenEditRowContract,
      setOpenEditFilterContract,
      setRowEditContract, 
      setIsLoadingErrorContract,
      setIdCodeDelete,
      setViewPDF,
      setActiveOffsetContract,
      setCurrencyOffsetContract,
      setRangeOffsetContract,
      setStoresToSelect,
      setUserAccountsToSelect, 
      setShowModalContractSettings,
      showModalContractSettings, 
      navigate,
      dispatch,
      setDestTrasTradenameToSelect,
      setOriTrasTradenameToSelect,
      setFilteredOriTrasStoreFrom,
      setHighlightedIndexOriTrasStoreFrom, 
      setFilteredOriTrasStoreTo,
      setHighlightedIndexOriTrasStoreTo, 
      setFilteredTransFrom,
      setHighlightedIndexDestTrasStoreFrom, 
      setFilteredTransTo,
      setHighlightedIndexDestTrasStoreTo,  
      DELETE_CODE]
  );

  const closeModalContract = () => {    
    setDataContract(initialStateContract);  
    setNumTotRegFilter(0);
    setNumTotRegContract(0);
    setErrorsFiltersContract({});
    setInputTextContract(""); 
    setOpenDeleteRowContract(false); 
    setOpenEditRowContract(false);
    setOpenEditFilterContract(false);
    setRowEditContract(initialStateContract[0]); 
    setIsLoadingErrorContract(false);
    setIdCodeDelete(DELETE_CODE);
    setViewPDF(false);
    setActiveOffsetContract(false);
    setCurrencyOffsetContract(0);
    setRangeOffsetContract([{}]);
    setStoresToSelect(initialStoresToSelect);
    setUserAccountsToSelect(initialUserAccountToSelect); 
    setShowModalContractSettings(false);
    dispatch(setLoading(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersContract(initialFiltersContracts);
    setDestTrasTradenameToSelect(initialStoresToSelect);
    setOriTrasTradenameToSelect(initialStoresToSelect);
    setFilteredOriTrasStoreFrom([]);
    setHighlightedIndexOriTrasStoreFrom(-1); 
    setFilteredOriTrasStoreTo([]);  
    setHighlightedIndexOriTrasStoreTo(-1);  
    setFilteredTransFrom([]);
    setHighlightedIndexDestTrasStoreFrom(-1);  
    setFilteredTransTo([]);
    setHighlightedIndexDestTrasStoreTo(-1);  
    navigate("/home");
    return () => {};
  };

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
  };
  
  // Dentro del componente
  const debouncedHandleSearchOriTrasStoreFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredOriTrasStoreFrom([]);
      setHighlightedIndexOriTrasStoreFrom(-1);
      return;
    }
    const filtered = oriTrasTradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredOriTrasStoreFrom(filtered);
    setHighlightedIndexOriTrasStoreFrom(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectOriTrasStoreFrom = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersContract(filtersContract => ({
      ...filtersContract,
      ori_tras_store_idFrom: store.tradename || "",
      ori_tras_store_idTo: store.tradename || filtersContract.ori_tras_store_idTo 
    }));
    setFilteredOriTrasStoreFrom([]);
    setHighlightedIndexOriTrasStoreFrom(-1);
  }; 
  const handleKeyDownOriTrasStoreFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredOriTrasStoreFrom.length === 0 && filtersContract.ori_tras_store_idFrom.trim() === "") {
        setFilteredOriTrasStoreFrom(oriTrasTradenameToSelect);
        setHighlightedIndexOriTrasStoreFrom(0);
      } else {
        setHighlightedIndexOriTrasStoreFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredOriTrasStoreFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexOriTrasStoreFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexOriTrasStoreFrom >= 0) {
      if (highlightedIndexOriTrasStoreFrom >= 0 && highlightedIndexOriTrasStoreFrom < filteredOriTrasStoreFrom.length) {
        handleSelectOriTrasStoreFrom(filteredOriTrasStoreFrom[highlightedIndexOriTrasStoreFrom]);
      }
    } else if (event.key === "Escape" ) {
      const isValid = oriTrasTradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersContract.ori_tras_store_idFrom.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFiltersContract(filtersContract => ({
          ...filtersContract,
          ori_tras_store_idFrom: ""
        }));
      }
      setFilteredOriTrasStoreFrom([]);
      setHighlightedIndexOriTrasStoreFrom(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchOriTrasStoreTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredOriTrasStoreTo([]);
      setHighlightedIndexOriTrasStoreTo(-1);
      return;
    }
    const filtered = oriTrasTradenameToSelect
      .filter(store=>(store.tradename>=filtersContract.ori_tras_store_idFrom))
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredOriTrasStoreTo(filtered);
    setHighlightedIndexOriTrasStoreTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectOriTrasStoreTo = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersContract(filtersContract => ({
    ...filtersContract,
    ori_tras_store_idTo:  store.tradename || ""
  }));
  setFilteredOriTrasStoreTo([]);
  setHighlightedIndexOriTrasStoreTo(-1);
  }; 
  const handleKeyDownOriTrasStoreTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredOriTrasStoreTo.length === 0 && filtersContract.ori_tras_store_idTo.trim() === "") {
        const filtered = oriTrasTradenameToSelect.filter(item=>(item.tradename>=filtersContract.ori_tras_store_idFrom));
        setFilteredOriTrasStoreTo(filtered);
        setHighlightedIndexOriTrasStoreTo(0);
      } else {
        setHighlightedIndexOriTrasStoreTo((prevIndex) => {
          const nextIndex = prevIndex < filteredOriTrasStoreTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexOriTrasStoreTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexOriTrasStoreTo >= 0) {
      if (highlightedIndexOriTrasStoreTo >= 0 && highlightedIndexOriTrasStoreTo < filteredOriTrasStoreTo.length) {
        handleSelectOriTrasStoreTo(filteredOriTrasStoreTo[highlightedIndexOriTrasStoreTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = oriTrasTradenameToSelect
      .filter(item=>(item.tradename>=filtersContract.ori_tras_store_idFrom))
      .some((store) => {
      if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersContract.ori_tras_store_idTo.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
    }); 
    if (!isValid) {
      setFiltersContract(filtersContract => ({
        ...filtersContract,
        ori_tras_store_idTo:  ""
      }));
    }
    setFilteredOriTrasStoreTo([]);
    setHighlightedIndexOriTrasStoreTo(-1);
    }
  };  

  // Dentro del componente
  const debouncedHandleSearchAutTrasStoreFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredTransFrom([]);
      setHighlightedIndexDestTrasStoreFrom(-1);
      return;
    }
    const filtered = destTrasTradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredTransFrom(filtered);
    setHighlightedIndexDestTrasStoreFrom(0);
  }, 300); 
// Manejo de la selección de una tienda
  const handleSelectDestTrasStoreFrom = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersContract(filtersContract => ({
      ...filtersContract,
      dest_tras_store_idFrom: store.tradename || "",
      dest_tras_store_idTo: store.tradename || filtersContract.dest_tras_store_idTo 
    }));
    setFilteredTransFrom([]);
    setHighlightedIndexDestTrasStoreFrom(-1);
  }; 
 const handleKeyDownTransFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTransFrom.length === 0 && filtersContract.dest_tras_store_idFrom.trim() === "") {
        setFilteredTransFrom(destTrasTradenameToSelect);
        setHighlightedIndexDestTrasStoreFrom(0);
      } else {
        setHighlightedIndexDestTrasStoreFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredTransFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexDestTrasStoreFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDestTrasStoreFrom >= 0) {
      if (highlightedIndexDestTrasStoreFrom >= 0 && highlightedIndexDestTrasStoreFrom < filteredTransFrom.length) {
        handleSelectDestTrasStoreFrom(filteredTransFrom[highlightedIndexDestTrasStoreFrom]);
      }
    } else if (event.key === "Escape" ) {
      const isValid = destTrasTradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersContract.dest_tras_store_idFrom.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFiltersContract(filtersContract => ({
          ...filtersContract,
          dest_tras_store_idFrom: ""
        }));
      }
      setFilteredTransFrom([]);
      setHighlightedIndexDestTrasStoreFrom(-1);
    }
  };
 // Dentro del componente
  const debouncedHandleSearchAutTrasStoreTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredTransTo([]);
      setHighlightedIndexDestTrasStoreTo(-1);
      return;
    }
    const filtered = destTrasTradenameToSelect
      .filter(store=>(store.tradename>=filtersContract.dest_tras_store_idFrom))
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredTransTo(filtered);
    setHighlightedIndexDestTrasStoreTo(0);
  }, 300);
 // Manejo de la selección de una tienda
  const handleSelectDestTrasStoreTo = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersContract(filtersContract => ({
    ...filtersContract,
    dest_tras_store_idTo:  store.tradename || ""
  }));
  setFilteredTransTo([]);
  setHighlightedIndexDestTrasStoreTo(-1);
  };  
  const handleKeyDownDesrTrasStoreTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTransTo.length === 0 && filtersContract.dest_tras_store_idTo.trim() === "") {
        const filtered = destTrasTradenameToSelect.filter(item=>(item.tradename>=filtersContract.dest_tras_store_idFrom));
        setFilteredTransTo(filtered);
        setHighlightedIndexDestTrasStoreTo(0);
      } else {
        setHighlightedIndexDestTrasStoreTo((prevIndex) => {
          const nextIndex = prevIndex < filteredTransTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexDestTrasStoreTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDestTrasStoreTo >= 0) {
      if (highlightedIndexDestTrasStoreTo >= 0 && highlightedIndexDestTrasStoreTo < filteredTransTo.length) {
        handleSelectDestTrasStoreTo(filteredTransTo[highlightedIndexDestTrasStoreTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = destTrasTradenameToSelect
      .filter(item=>(item.tradename>=filtersContract.dest_tras_store_idFrom))
      .some((store) => {
      if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersContract.dest_tras_store_idTo.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
    }); 
    if (!isValid) {
      setFiltersContract(filtersContract => ({
        ...filtersContract,
        dest_tras_store_idTo:  ""
      }));
    }
    setFilteredTransTo([]);
    setHighlightedIndexDestTrasStoreTo(-1);
    }
  };  
 
  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  
  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setFilteredOriTrasStoreFrom([]);
      setHighlightedIndexOriTrasStoreFrom(-1); 
      setFilteredOriTrasStoreTo([]);  
      setHighlightedIndexOriTrasStoreTo(-1);   
      setFilteredTransFrom([]);
      setHighlightedIndexDestTrasStoreFrom(-1); 
      setFilteredTransTo([]);
      setHighlightedIndexDestTrasStoreTo(-1);
    }
  }, []); 
 
  const openCreateOrEditDataContract = () => {
    setInputTextContract(""); 
    setOpenEditFilterContract(!openEditFilterContract);
    navigate("/contractdetail/0");
  };
   
  const openEditFiltersContract = () => { 
    setOpenEditFilterContract(!openEditFilterContract);
  };

  const handleSubmitFilterEditContract = () => {
    setErrorsFiltersContract(validateFormFilterContract());
    if (Object.keys(errorsFiltersContract).length === 0) {
      setErrorsFiltersContract({}); 
      dispatch(resetPagination());
      dispatch(setFilters(filtersContract));  
      setOpenEditFilterContract(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }

  const handleDeleteFiltersContract = () => {
    setErrorsFiltersContract({});
    dispatch(resetFilters());
    dispatch(resetPagination());
    setFiltersContract(initialFiltersContracts); 
    setOpenEditFilterContract(!openEditFilterContract);
  };

  const handleCancelFiltersContract = () => {
    setErrorsFiltersContract({});
    setOpenEditFilterContract(!openEditFilterContract);
  };
 
  const handleChangeSelectDateContract = (event) => {
    setFiltersContract(filtersContract => ({
      ...filtersContract,
      dateContractFrom: event!==null?new Date(event):null,
      dateContractTo:null
    }));
  };

  const handleBlurSelectDateContractFrom = (e) => {
    handleChangeSelectDateContract(e);
    setErrorsFiltersContract(validateFormFilterContract());
  };

  const handleChangeSelectDateContractTo = (event) => {
    setFiltersContract(filtersContract => ({
      ...filtersContract,
      dateContractTo: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectDateContractTo = (e) => {
    handleChangeSelectDateContractTo(e);
    setErrorsFiltersContract(validateFormFilterContract());
  };
    
  const handleChangeFilterEditContract = (e) => {
    const { name, value } = e.target;
    setFiltersContract(filtersContract => ({
      ...filtersContract,
      [name]: value
    }));
  };

  const handleBlurFilterEditContract = (e) => {
    setErrorsFiltersContract(validateFormFilterContract());
    handleChangeFilterEditContract(e);
  };

  const toggleDrawerFilterEditContract = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditContract();
    }
  };

  const validateFormFilterContract = () => {

    let errorsFiltersContract = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersContract.idFrom!=="" & !regexNumber.test(filtersContract.idFrom)) {
      errorsFiltersContract.idFrom = 'Text_TextNoNumber';
    }
    if (filtersContract.idTo!=="" & !regexNumber.test(filtersContract.idTo)) {
      errorsFiltersContract.idTo = 'Text_TextNoNumber';
    }
    if (filtersContract.idFrom!=="" & !errorsFiltersContract.idFrom!==undefined){
      if (filtersContract.idTo!=="" & !errorsFiltersContract.idTo!==undefined){
        if (parseInt(filtersContract.idTo)<parseInt(filtersContract.idFrom)){
          errorsFiltersContract.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (filtersContract.defaultStoreIdTo!=="" & filtersContract.defaultStoreIdTo<filtersContract.defaultStoreIdFrom){
      errorsFiltersContract.defaultStoreIdTo = 'Text_TextGreater_Store';
    }

    if (filtersContract.useraccountIdTo!=="" & filtersContract.useraccountIdTo<filtersContract.useraccountIdFrom){
      errorsFiltersContract.useraccountIdTo = 'Text_TextGreater_UserAccount';
    }

    if (regexInvalidCharacters.test(filtersContract.numberNTrom)) {
      errorsFiltersContract.numberNTrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersContract.numberNTTo)) {
      errorsFiltersContract.numberNTTo = 'Text_TextNoValid';
    }

    if (filtersContract.numberNTTo!=="" & filtersContract.numberNTTo<filtersContract.numberNTrom){
      errorsFiltersContract.numberNTTo = 'Text_TextGreater_numberNTTo';
    }

    if (filtersContract.dateContractTo!==null & filtersContract.dateContractTo<filtersContract.dateContractFrom){
      errorsFiltersContract.dateContractTo = 'Text_TextGreater_Date';
    }
    return errorsFiltersContract;
  }  

  const filteredDataContract = dataContract.filter((el) => {
    if (inputTextContract === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') + 
        String(el.number_nt || '');
      let result = dataTranslate.toLowerCase().includes(inputTextContract.toLowerCase());
      return result;
    }
  })

  let inputHandlerContract = (e) => {
      var lowerCase = e.target.value.toLowerCase();
      setInputTextContract(lowerCase);
  };

  const handleChangeDeleteRowContract = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };

  const handleCancelDeleteRowContract = () => {
    setRowEditContract(initialStateContract[0]);
    setIsLoadingErrorContract(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowContract(false);
  };

  const handleCloseDeleteRowFormDI = (e) => {
    if (idCodeDelete !== DELETE_CODE_FORMDI) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    let isMounted = true;
    if (e.key !== 'Escape') {
      if (rowEditContract.id!=='') {      
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT,`contract/deletecontract  `,token,rowEditContract);
            if (getData.status === "OK") {
              if (isMounted) {
                dispatch(successErrorAction(t('Text_ValidCode')));
                dispatch(successErrorAction(t('Text_DeleteField')));
                handleCloseDataEditContract();
              }
            } else {
              if (isMounted) {
                dispatch(warningErrorAction(t(getData.cause)));
              }
            }
            dispatch(setLoading(false));
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }  
        };
        fetchData();
      
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    }
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowContract(false);
    setIsLoadingErrorContract(false);
    handleCloseDataEditContract(); 
  };
 
  const handleCloseDataEditContract = () => { 
    setOpenEditRowContract(false);
    setRowEditContract(openEditRowContract?rowEditContract:initialStateContract[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorContract(false);
    toggleDrawerFilterEditContract(false);  
	};
  
  const handleExport = () => { 
    const fetchDataRegisterBook = async () => {
      dispatch(setLoading(true));
      try {
        const getData =
        menuPermissions.storeMaster?
        await helpHttp().post7(ENDPOINT,`contract/getcontracttoexcel`,token,currencyOffsetContract,LIMITPAGESIZE,"-1","-1",filtersContractsDetails):
        menuPermissions.userMaster?
        await helpHttp().post7(ENDPOINT,`contract/getcontracttoexcel`,token,currencyOffsetContract,LIMITPAGESIZE,"-1",useraccount_id,filtersContractsDetails):
        await helpHttp().post7(ENDPOINT,`contract/getcontracttoexcel`,token,defaultStore.id,useraccount_id,filtersContractsDetails);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (getData && getData.length>0) {
          exportContractToExcel(getData, "CONTRATOS"); 
        }
        dispatch(setLoading(false)); 
      } catch (error) {
        dispatch(setLoading(false)); 
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    if (dataContract && dataContract.length>0){ 
      fetchDataRegisterBook();
    } 
  };
  
  useEffect(() => {
    if (numTotRegContract > Number(LIMITPAGESIZE)) {
      setActiveOffsetContract(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMITPAGESIZE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMITPAGESIZE); i < numTotRegContract; i += Number(LIMITPAGESIZE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMITPAGESIZE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffsetContract(newRangeOffset);
    } else {
      setCurrencyOffsetContract(0);
      setActiveOffsetContract(false);
      setRangeOffsetContract([{}]);
    }
  }, [numTotRegContract,LIMITPAGESIZE]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataOriTras = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`contract/getlistoritrastradename`,token); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setOriTrasTradenameToSelect(getData); 
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  

    const fetchDataDestTras = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`contract/getlisdestrastradename`,token); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDestTrasTradenameToSelect(getData); 
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   

    if (showModalContractSettings ) { 
      fetchDataOriTras();
      fetchDataDestTras();  
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,openEditFilterContract,showModalContractSettings]);
    
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
  useEffect(() => {
    let isMounted = true;
    const fetchnumTotRegContract = async () => { 
      try {
        const getData  = menuPermissions.storeMaster
        ? await helpHttp().get(ENDPOINT,`contract/getinformationtablecontract`,token)
        : (menuPermissions.userMaster?
            await helpHttp().get2(ENDPOINT,`contract/getinformationtablecontractwithstore/`,token,defaultStore.id):
            await helpHttp().get8(ENDPOINT,`contract/getinformationtablecontractwithstoreanduseraccount`,token,defaultStore.id,useraccount_id))
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataContract(initialStateContract);
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            }  
          }
        } else if (isMounted) {
          setNumTotRegContract(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = 
        menuPermissions.storeMaster?
        await helpHttp().get3(ENDPOINT,`contract/getcountfiltercontract`,token,"-1","-1",filtersContractsDetails):
        menuPermissions.userMaster?
        await helpHttp().get3(ENDPOINT,`contract/getcountfiltercontract`,token,"-1",useraccount_id,filtersContractsDetails):
        await helpHttp().get3(ENDPOINT,`contract/getcountfiltercontract`,token,defaultStore.id,useraccount_id,filtersContractsDetails);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataContract(initialStateContract);
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } 
          }
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    }; 
 
    const fetchDataStore = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`contract/storesorderbytradename`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setStoresToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataUserAccount = async () => {
      try {
        const getData =menuPermissions.storeMaster?
            await helpHttp().get2(ENDPOINT,`contract/useraccountsorderbyusername/`,token,"-1"):
            await helpHttp().get2(ENDPOINT,`contract/useraccountsorderbyusername/`,token,defaultStore.id);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setUserAccountsToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 

    const fetchDataContract = async () => {
      dispatch(setLoading(true));
      try {
        const getData = 
        menuPermissions.storeMaster?
        await helpHttp().post7(ENDPOINT,`contract/getcontract`,token,currencyOffsetContract,LIMITPAGESIZE,"-1","-1",filtersContractsDetails):
        menuPermissions.userMaster?
        await helpHttp().post7(ENDPOINT,`contract/getcontract`,token,currencyOffsetContract,LIMITPAGESIZE,"-1",useraccount_id,filtersContractsDetails):
        await helpHttp().post7(ENDPOINT,`contract/getcontract`,token,defaultStore.id,useraccount_id,filtersContractsDetails);
        if (getData.err) {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataContract(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
 
    if (showModalContractSettings){
      fetchnumTotRegContract();
      fetchnumTotRegFilter(); 
      fetchDataContract();
      if (menuPermissions.storeMaster){
        fetchDataStore();
      }
      if (menuPermissions.userMaster){
        fetchDataUserAccount();
      } 
    }  
    return () => { isMounted = false; };
  }, [t,token,dispatch,LIMITPAGESIZE,i18n.language,filtersContractsDetails,showModalContractSettings,currencyOffsetContract,defaultStore.id,useraccount_id ,openDeleteRowContract,
    menuPermissions.storeMaster,menuPermissions.userMaster,setOpenDeleteRowContract,setOpenEditRowContract,openEditRowContract,rowEditContract,setRowEditContract,defaultStore ]);
     
   return (
    <>
      {showModalContractSettings ? ( 
       <div className="container-fluid formdi-pending-page">
          {/* Search input */}
          <div id="myDIV" className="formdi-pending-header">
           <h1 className="formdi-pending-title">
            {isLoadingErrorContract?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={openDeleteRowContract?"warning":"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_Contracts_Table')}</h1>
              {menuPermissions.canCreate ?
                <div>
                  <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditDataContract} >
                    {t('Button_Create')}
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalContract} >
                    {t("Button_Back")}
                  </button> 
                </div>:
                 <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalContract} >
                  {t("Button_Back")}
                </button>
               
              }
          </div>  
          <br/>
          <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={inputTextContract}
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              placeholder={t('Text_CONTRACT_Search')} 
              onChange={inputHandlerContract}
              fullWidth
              label={t('Text_CONTRACT_Search')}>
            </TextField>
          </div>
          <br/>
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${filtersContractsDetails.idFrom !== "" || filtersContractsDetails.idTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersContract} >
                <span className={`formdi-pending-dot ${ filtersContractsDetails.idFrom !== "" || filtersContractsDetails.idTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Code")}
              </button>
              {menuPermissions.storeMaster &&
                <>
                 <button type="button" className={`formdi-pending-chip ${filtersContractsDetails.defaultStoreIdFrom !== "" || filtersContractsDetails.defaultStoreIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersContract} >
                    <span className={`formdi-pending-dot ${ filtersContractsDetails.defaultStoreIdFrom !== "" || filtersContractsDetails.defaultStoreIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                      {t("Text_Store")}
                  </button> 
                </> 
                }
                 {menuPermissions.userMaster &&
                  <>
                    <button type="button" className={`formdi-pending-chip ${filtersContractsDetails.useraccountIdFrom !== "" || filtersContractsDetails.useraccountIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersContract} >
                      <span className={`formdi-pending-dot ${ filtersContractsDetails.useraccountIdFrom !== "" || filtersContractsDetails.useraccountIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_UserAccount")}
                    </button>
                  </> 
                }
                <button type="button" className={`formdi-pending-chip ${filtersContractsDetails.numberNTrom !== "" || filtersContractsDetails.numberNTTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersContract} >
                  <span className={`formdi-pending-dot ${ filtersContractsDetails.numberNTrom !== "" || filtersContractsDetails.numberNTTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_CONTRACT_NT_CONTRACT")}
                </button>
                <button type="button" className={`formdi-pending-chip ${filtersContractsDetails.dateContractFrom!==null || filtersContractsDetails.dateContractTo!==null ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersContract} >
                  <span className={`formdi-pending-dot ${ filtersContractsDetails.dateContractFrom!==null || filtersContractsDetails.dateContractTo!==null? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Date")}
                </button>
                 <button type="button" className={`formdi-pending-chip ${filtersContractsDetails.ori_tras_store_idFrom 
                      || filtersContractsDetails.ori_tras_store_idTo
                      || filtersContractsDetails.dest_tras_store_idFrom
                      || filtersContractsDetails.dest_tras_store_idTo  ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersContract} >
                  <span className={`formdi-pending-dot ${ filtersContractsDetails.ori_tras_store_idFrom 
                      || filtersContractsDetails.ori_tras_store_idTo
                      || filtersContractsDetails.dest_tras_store_idFrom
                      || filtersContractsDetails.dest_tras_store_idTo ? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Others_Filters")}
                </button>
                <> </>  
                { menuPermissions.canExcel&&
                  <>
                    <button type="button" className="formdi-excel-chip" onClick={handleExport}>{t('Button_Excel')}</button><> </> 
                  </>
                }                
            </div>
          </div>
          <br/>

          {!isLoadingData ?
            <>
              <div className="formdi-pending-card-flat">
                <div className="formdi-pending-card-content">
                  <TableSortingContract
                      dataContract={filteredDataContract} 
                      numTotRegFilter={ numTotRegFilter}
                      titleTable={t('Text_CONTRACT_Table')}
                      setOpenDeleteRowContract={setOpenDeleteRowContract}
                      setRowEditContract={setRowEditContract}
                      showEditButtonContract={menuPermissions.canEdit}
                      showPrintButtonContract={menuPermissions.canPrint}
                      showDeleteButtonContract={menuPermissions.canDelete}
                      showEmailButtonContract={menuPermissions.canHandleEmails}
                      showStoreContract={menuPermissions.canShowStores}
                      showUserAccountContract={menuPermissions.userMaster}
                      numTotRegContract={numTotRegContract}
                      activeOffsetContract={activeOffsetContract}
                      rangeOffsetContract={rangeOffsetContract}
                      currencyOffsetContract={currencyOffsetContract}
                      setCurrencyOffsetContract={setCurrencyOffsetContract} 
                      setViewPDF={setViewPDF} 
                    > 
                    </TableSortingContract>
                </div>             
              </div> 
              {openEditFilterContract &&
               <div>
               <SwipeableDrawer
                 anchor='right'
                 open={true}
                 onClose={toggleDrawerFilterEditContract(false)}
                 onOpen={toggleDrawerFilterEditContract(true)}>
                 <Container >
                   <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                     <br/>
                       <div id="myDIV">
                         <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                       </div>
                       <hr className="sidebar-divider d-none d-md-block"/>
                       <form className="createfiltercontract" onSubmit={handleCancelFiltersContract}>  
                         <div className="form-floating mb-3 px-4 primary">
                           <div className="form-group">
                             <TextField
                              id="idFrom" 
                              name="idFrom"
                              value={filtersContract.idFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersContract.idFrom!=null?t(errorsFiltersContract.idFrom):t('Text_Filter_Code_From')}
                              placeholder={t('PlaceHolder_Filter_Code_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditContract}
                              onChange={handleChangeFilterEditContract}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                             <TextField
                              id="idTo" 
                              name="idTo"
                              value={filtersContract.idTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersContract.idTo!=null?t(errorsFiltersContract.idTo):t('Text_Filter_Code_To')}
                              placeholder={t('PlaceHolder_Filter_Code_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditContract}
                              onChange={handleChangeFilterEditContract}/>
                           </div>
                           {menuPermissions.storeMaster   &&
                              <>
                                <Suspense delayMs={500} fallback={<CircularProgress sx={{ color :"#f6c23e"}}/>}>
                                  <div className="form-group">
                                    <TextField
                                      id="defaultStoreIdFrom"
                                      name="defaultStoreIdFrom"
                                      value={filtersContract.defaultStoreIdFrom}
                                      inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersContract.defaultStoreIdFrom!=null?t(errorsFiltersContract.defaultStoreIdFrom):t('Text_Filter_Store_From')}
                                      placeholder={t('PlaceHolder_Filter_Store_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditContract}
                                      onChange={handleChangeFilterEditContract}
                                      select
                                      SelectProps={{
                                      native: true,
                                      }}>
                                      <option key={0} value=""/>
                                      {storesToSelect.map((option) => (
                                          <option key={option.id} value={option.id}>
                                             {option.documentid+" - "+option.tradename}
                                          </option>
                                      ))}
                                    </TextField>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                        id="defaultStoreIdTo"
                                        name="defaultStoreIdTo"
                                        value={filtersContract.defaultStoreIdTo}  
                                        inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                        label={errorsFiltersContract.defaultStoreIdTo!=null?t(errorsFiltersContract.defaultStoreIdTo):t('Text_Filter_Store_To')}
                                        placeholder={t('PlaceHolder_Filter_Store_to')}
                                        variant="outlined"
                                        onBlur={handleBlurFilterEditContract}
                                        onChange={handleChangeFilterEditContract}
                                        select
                                        SelectProps={{
                                        native: true,
                                        }}>
                                         <option key={0} value=""/>
                                        {storesToSelect.filter(item=>(item.id>=filtersContract.defaultStoreIdFrom)).map(option => (
                                          <option key={option.id} value={option.id}>
                                              {option.documentid+" - "+option.tradename}
                                          </option>
                                        ))}
                                      </TextField>
                                    </div>
                                </Suspense>
                            </>
                           }   
                           {menuPermissions.userMaster   &&
                              <>
                                <Suspense delayMs={500} fallback={<CircularProgress sx={{ color :"#f6c23e"}}/>}>
                                  <div className="form-group">
                                    <TextField
                                      id="useraccountIdFrom"
                                      name="useraccountIdFrom"
                                      value={filtersContract.useraccountIdFrom}
                                      inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersContract.useraccountIdFrom!=null?t(errorsFiltersContract.useraccountIdFrom):t('Text_Filter_UserAccount_From')}
                                      placeholder={t('PlaceHolder_UserAccount_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditContract}
                                      onChange={handleChangeFilterEditContract}
                                      select
                                      SelectProps={{
                                      native: true,
                                      }}>
                                      <option key={0} value=""/>
                                      {userAccountsToSelect.map((option) => (
                                          <option key={option.id} value={option.username}>
                                            {option.username+" - "+option.email}
                                          </option>
                                      ))}
                                    </TextField>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                        id="useraccountIdTo"
                                        name="useraccountIdTo"
                                        value={filtersContract.useraccountIdTo}  
                                        inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                        label={errorsFiltersContract.useraccountIdTo!=null?t(errorsFiltersContract.useraccountIdTo):t('Text_Filter_UserAccount_To')}
                                        placeholder={t('PlaceHolder_UserAccount_To')}
                                        variant="outlined"
                                        onBlur={handleBlurFilterEditContract}
                                        onChange={handleChangeFilterEditContract}
                                        select
                                        SelectProps={{
                                        native: true,
                                        }}>
                                         <option key={0} value=""/>
                                        {userAccountsToSelect.filter(item=>(item.username>=filtersContract.useraccountIdFrom)).map(option => (
                                          <option key={option.id} value={option.username}>
                                              {option.username+" - "+option.email}
                                          </option>
                                        ))}
                                      </TextField>
                                    </div>
                                </Suspense>
                            </>
                           }   
                           <div className="form-group">
                             <TextField
                              id="numberNTrom" 
                              name="numberNTrom"
                              value={filtersContract.numberNTrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersContract.numberNTrom!=null?t(errorsFiltersContract.numberNTrom):t('Text_Filter_NumberNT_From')}
                              placeholder={t('PlaceHolder_Filter_NumberNT_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditContract}
                              onChange={handleChangeFilterEditContract}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                             <TextField
                              id="numberNTTo" 
                              name="numberNTTo"
                              value={filtersContract.numberNTTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersContract.numberNTTo!=null?t(errorsFiltersContract.numberNTTo):t('Text_Filter_NumberNT_To')}
                              placeholder={t('PlaceHolder_Filter_NumberNT_To')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditContract}
                              onChange={handleChangeFilterEditContract}/>
                           </div>
                         
                          <div className="form-group">
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <DesktopDatePicker
                                  id="dateContractFrom" 
                                  name="dateContractFrom"
                                  value={ filtersContract.dateContractFrom!== null ? new Date(filtersContract.dateContractFrom): null}
                                  format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                  label={errorsFiltersContract.dateContractFrom!=null?t(errorsFiltersContract.dateContractFrom):t('PlaceHolder_Filter_DateSheet_From')}
                                  onBlur={handleBlurSelectDateContractFrom}
                                  onChange={handleChangeSelectDateContract}
                                  slotProps={{
                                    textField: {
                                      placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                      sx: {
                                        color: '#1565c0',
                                        maxLength: '100',
                                        width: 430,  
                                        fontSize: '18px'
                                      },
                                      InputProps: {
                                        style: {
                                          fontSize: '18px',
                                        }
                                      },
                                      InputLabelProps:{ 
                                        style: {
                                          fontSize: '18px', 
                                          background: '#FFFFFF'
                                        }
                                      },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                <DesktopDatePicker
                                  id="dateContractTo" 
                                  name="dateContractTo"
                                  minDate={filtersContract.dateContractFrom!== null ? new Date(filtersContract.dateContractFrom): null}
                                  value={ filtersContract.dateContractTo!== null ? new Date(filtersContract.dateContractTo): null}
                                  format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                  label={errorsFiltersContract.dateContractTo!=null?t(errorsFiltersContract.dateContractTo):t('PlaceHolder_Filter_DateSheet_To')}
                                  onBlur={handleBlurSelectDateContractTo}
                                  onChange={handleChangeSelectDateContractTo}
                                  slotProps={{
                                    textField: {
                                      placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                      sx: {
                                        color: '#1565c0',
                                        maxLength: '100',
                                        width: 430,  
                                        fontSize: '18px'
                                      },
                                      InputProps: {
                                        style: {
                                          fontSize: '18px',
                                        }
                                      },
                                      InputLabelProps:{ 
                                        style: {
                                          fontSize: '18px', 
                                          background: '#FFFFFF'
                                        }
                                      },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                          </div>           
                          <div className="form-group">
                            {/* Campo de texto para escribir y filtrar */}
                            <span style={{ position: "relative" }}>
                              <TextField
                                id="ori_tras_store_idFrom"
                                name="ori_tras_store_idFrom"
                                value={filtersContract.ori_tras_store_idFrom}
                                onChange={(e) => {
                                  setFiltersContract(prev => ({
                                    ...prev,
                                    ori_tras_store_idFrom: e.target.value.toUpperCase(),
                                    ori_tras_store_idTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchOriTrasStoreFrom(e.target.value);
                                }}
                                onKeyDown={handleKeyDownOriTrasStoreFrom}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersContract.ori_tras_store_idFrom != null
                                  ? t(errorsFiltersContract.ori_tras_store_idFrom)
                                  : t('Text_Filter_OriTras_From')}
                                placeholder={t('PlaceHolder_Filter_OriTras_From')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredOriTrasStoreFrom.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredOriTrasStoreFrom.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectOriTrasStoreFrom(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexOriTrasStoreFrom ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexOriTrasStoreFrom ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )} 
                              </span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                              <span style={{ position: "relative" }} >
                              <TextField
                                id="ori_tras_store_idTo"
                                name="ori_tras_store_idTo"
                                value={filtersContract.ori_tras_store_idTo}
                                onChange={(e) => {
                                  setFiltersContract(prev => ({
                                    ...prev,
                                    ori_tras_store_idTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchOriTrasStoreTo(e.target.value);
                                }}
                                onKeyDown={handleKeyDownOriTrasStoreTo}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersContract.ori_tras_store_idTo != null
                                  ? t(errorsFiltersContract.ori_tras_store_idTo)
                                  : t('Text_Filter_OriTras_To')}
                                placeholder={t('PlaceHoldert_Filter_OriTras_To')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredOriTrasStoreTo.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredOriTrasStoreTo.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectOriTrasStoreTo(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexOriTrasStoreTo ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexOriTrasStoreTo ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>
                          </div> 
                            
                          <div className="form-group">
                            <span style={{ position: "relative" }}>
                              <TextField
                                id="dest_tras_store_idFrom"
                                name="dest_tras_store_idFrom"
                                value={filtersContract.dest_tras_store_idFrom}
                                onChange={(e) => {
                                  setFiltersContract(prev => ({
                                    ...prev,
                                    dest_tras_store_idFrom: e.target.value.toUpperCase(),
                                    dest_tras_store_idTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchAutTrasStoreFrom(e.target.value);
                                }}
                                onKeyDown={handleKeyDownTransFrom}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersContract.dest_tras_store_idFrom != null
                                  ? t(errorsFiltersContract.dest_tras_store_idFrom)
                                  : t('Text_Filter_DestTras_From')}
                                placeholder={t('PlaceHolder_Filter_DestTras_From')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredTransFrom.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredTransFrom.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectDestTrasStoreFrom(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexDestTrasStoreFrom ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDestTrasStoreFrom ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )} 
                              </span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                              <span style={{ position: "relative" }} >
                              <TextField
                                id="dest_tras_store_idTo"
                                name="dest_tras_store_idTo"
                                value={filtersContract.dest_tras_store_idTo}
                                onChange={(e) => {
                                  setFiltersContract(prev => ({
                                    ...prev,
                                    dest_tras_store_idTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchAutTrasStoreTo(e.target.value);
                                }}
                                onKeyDown={handleKeyDownDesrTrasStoreTo}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersContract.dest_tras_store_idTo != null
                                  ? t(errorsFiltersContract.dest_tras_store_idTo)
                                  : t('Text_Filter_DestTras_To')}
                                placeholder={t('PlaceHolder_Filter_DestTras_To')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredTransTo.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredTransTo.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectDestTrasStoreTo(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexDestTrasStoreTo ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDestTrasStoreTo ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>
                          </div>          
                        </div>
                        <hr className="sidebar-divider d-none d-md-block" />
                          <div className="formdi-pending-action-group">
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditContract}>
                              {t('Button_Apply')}
                            </button> 
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersContract}>
                              {t('Button_Cancel_Filters')}
                            </button>
                         </div>   
                     </form>
                   </Box>
                 </Container>
               </SwipeableDrawer>
              </div>
              }  
              <ContractPDF 
                rowEditContract={rowEditContract} 
                viewPDF={viewPDF} 
                setViewPDF={setViewPDF}
              />
              <Dialog open={openDeleteRowContract} onClose={handleCancelDeleteRowContract} PaperProps={{ className: "my-dialog-paper-danger" }} >
                <DialogTitle className="my-dialog-title-danger">
                  {t('Text_Delete')} {rowEditContract.id}  - {rowEditContract.number_nt} - {rowEditContract.opt_tras_tradename} 
                </DialogTitle>
                  <DialogContent>
                    <DialogContentText className="my-dialog-contentText-danger">
                      {t("Text_Line1")}<br />
                      {t("Text_Line2")}
                    </DialogContentText>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="idCode"
                        label={t("Text_Label")}
                        type="text"
                        fullWidth
                        variant="standard"
                        className="my-dialog-input-danger"
                        defaultValue={idCodeDelete}
                        onChange={handleChangeDeleteRowContract}
                      />
                    </DialogContent>
                  <DialogActions className="my-dialog-actions">
                  <Button
                    onClick={handleCancelDeleteRowContract}
                    className="my-dialog-button-cancel-danger"
                  >
                    {t("Button_Cancel")}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCloseDeleteRowFormDI}
                    className="my-dialog-button-delete"
                  >
                    {t("Button_Delete")}
                  </Button>
                </DialogActions>
              </Dialog> 
              {/* End Content Row */}
          </>:
            <LoadingNews/>
          }
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )
}

ContractFilter.propTypes = {
  showModalContractSettings: PropTypes.bool.isRequired,
  setShowModalContractSettings: PropTypes.func.isRequired
};

export default ContractFilter;

